// Custom TailwindCSS modals for confirm dialogs
//
// Example usage:
//
//   <%= button_to "Delete", my_path, method: :delete, form: {
//     data: {
//       turbo_confirm: "Are you sure?",
//       turbo_confirm_description: "This will delete your record. Enter the record name to confirm.",
//       turbo_confirm_text: "record name"
//     }
//   } %>

function insertConfirmModal(message, element, button) {
  let confirmInput = ""

  // button is nil if using link_to with data-turbo-confirm
  let confirmText = button?.dataset?.turboConfirmText || element.dataset.turboConfirmText
  let description = button?.dataset?.turboConfirmDescription || element.dataset.turboConfirmDescription || ""
  if (confirmText) {
    confirmInput = `<input type="text" class="mt-4 px-4 py-2 shadow-sm text-primary-500 bg-slate-800 border-slate-700 rounded focus:ring-0 focus:border-slate-600" data-behavior="confirm-text" />`
  }
  let id = `confirm-modal-${new Date().getTime()}`

  let content = `
    <dialog id="${id}" class="relative max-w-lg rounded-lg shadow-lg shadow-slate-800/80 bg-slate-950 border-slate-500 border backdrop:bg-slate-900/80">
      <form method="dialog">
        <div class="p-6">
          <h5 class="text-slate-200 font-extrabold tracking-tight text-xl sm:text-1xl md:text-2xl sm:tracking-normal sm:leading-tight">${message}</h5>
          <p class="mt-2 text-sm text-slate-300">${description}</p>

          ${confirmInput}

          <div class="flex justify-end items-center flex-wrap gap-2 mt-4">
            <button value="cancel" class="flex items-center max-w-min text-nowrap rounded-full cursor-pointer transition ease-in-out duration-300 disabled:cursor-not-allowed px-2 py-1 border border-white text-slate-50 hover:bg-primary-500 hover:border-primary-500 hover:text-slate-950 text-sm px-1.5 sm:px-3 sm:py-2 sm:font-bold btn btn-danger btn-outline primary">Cancel</button>
            <button value="confirm" class="flex items-center max-w-min text-nowrap rounded-full cursor-pointer transition ease-in-out duration-300 disabled:cursor-not-allowed px-2 py-1 border border-primary-500 text-slate-950 bg-primary-500 hover:bg-transparent hover:text-primary-500 text-sm px-1.5 sm:px-3 sm:py-2 sm:font-bold disabled:hover:bg-primary-500 disabled:hover:text-slate-950 disabled:opacity-50">Confirm</button>
          </div>
        </div>
      </form>
    </dialog>
  `

  document.body.insertAdjacentHTML('beforeend', content)
  let modal = document.getElementById(id)

  // Focus on the first button in the modal after rendering
  modal.querySelector("button").focus()

  // Disable commit button until the value matches confirmText
  if (confirmText) {
    let commitButton = modal.querySelector("[value='confirm']")
    commitButton.disabled = true
    modal.querySelector("input[data-behavior='confirm-text']").addEventListener("input", (event) => {
      commitButton.disabled = (event.target.value != confirmText)
    })
  }

  return modal
}

Turbo.config.forms.confirm = (message, element, button) => {
  let dialog = insertConfirmModal(message, element, button)
  dialog.showModal()

  return new Promise((resolve, reject) => {
    dialog.addEventListener("close", () => {
      resolve(dialog.returnValue == "confirm")
    }, { once: true })
  })
}
